module.exports = __webpack_public_path__ + "img/iahs.1d2f6dec.png";